import { render } from "./SupportSectionContent.vue?vue&type=template&id=102390ce"
import script from "./SupportSectionContent.vue?vue&type=script&lang=js"
export * from "./SupportSectionContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__